













/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Prop, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    computed: {
        organisationRoute() {
            return `/organisation/${ this.organisation.id }`;
        }
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class OrganisationItem extends Vue {
    @Prop() organisation!: string
};

